export default __webpack_public_path__ + "static/media/icon_online-payments.81599187.svg";